import React from "react";

export type CheckItem = { id: number; description: string };

type CheckCardProps = {
    title: string;
    icon: string;
    items: readonly CheckItem[];
};

const CheckCard = ({ title, icon, items }: CheckCardProps) => (
    <div className="con_img relative isolate w-full overflow-hidden rounded-lg bg-white px-8 py-8 shadow-card md:min-h-72">
        <div
            className="absolute inset-0 -z-10 bg-right-bottom bg-[length:auto_120px] bg-no-repeat px-8 py-8 opacity-40 md:bg-[image:var(--card-icon)]"
            style={{ "--card-icon": `url('${icon}')` } as React.CSSProperties}
        />

        <h2 className="mb-4 justify-start text-h2 font-bold text-brand">
            {title}
        </h2>

        <div className="flex flex-col gap-2">
            {items.map(item => (
                <div key={item.id} className="flex items-center gap-2">
                    <span className="mt-1 block h-[16px] w-[16px] shrink-0 bg-[url('/public/img/dreamfactory/list_icon.svg')] bg-contain bg-no-repeat" />
                    <p className="text-body font-normal tracking-[-0.01em] text-zinc-800">
                        {item.description}
                    </p>
                </div>
            ))}
        </div>
    </div>
);

export default CheckCard;
